export function canHoldParticipant(participant) {
  return participant.status === 'connected' || participant.status === 'on_hold'
}

export function participantHoldTooltip(participant) {
  if (participant.status === 'on_hold') return 'Resume: take them off hold'
  if (canHoldParticipant(participant)) return 'Hold: they hear hold music and the call carries on without them'
  return 'Hold is available once they pick up'
}

export function participantRemoveTooltip(participant) {
  if (canHoldParticipant(participant)) return 'Remove from call: hang up on them'
  return 'Cancel: stop dialing them'
}

export function othersOnCall(participants) {
  return participants.filter((participant) => participant.label !== 'provider' && canHoldParticipant(participant)).length
}

export function isMultiPartyCall(participants) {
  return othersOnCall(participants) >= 2
}

export const END_FOR_EVERYONE_TOOLTIP = 'End the call for everyone. Use Leave call to drop off and let the others keep talking.'
export const HANG_UP_TOOLTIP = 'Hang up and end the call'
export const LEAVE_CALL_TOOLTIP = 'Leave the call. Everyone else stays connected.'
